export default function validateInfo(values) {
  let errors = {};

  if (!values.name.trim() || values.name.length < 5) {
    errors.name = 'El nombre debe tener al menos 5 caracteres';
  }

  if (!values.email) {
    errors.email = 'form.error.email';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'form.error.email_invalid';
  }

  if (!values.message.trim() || values.message.length < 10) {
    errors.message = 'El mensaje no puede estar vacío y debe tener al menos 10 caracteres';
  }

  if (!values.subject.trim() || values.subject.length < 6) {
    errors.subject = 'El asunto no puede estar vacío y debe tener al menos 6 caracteres';
  }

  if (!values.phone.trim()) {
    errors.phone = 'Campo requerido';
  } else if (!/^\d{10}$/.test(values.phone)) {
    errors.phone = 'Número de teléfono no válido y debe tener 10 caracteres';
  }

  return errors;
}
